// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
// This file is derived from coinbase-wallet-sdk/packages/wallet-sdk/src/provider/CoinbaseWalletProvider.ts (2022/08/01).
// Modified for the klip-web3-provider development.

// const { prepare, getResult } = require('klip-sdk');
import SafeEventEmitter from '@metamask/safe-event-emitter';
// import { convertHexToUtf8 } from '@walletconnect/utils';
import { ethErrors } from 'eth-rpc-errors';
import { BigNumber, ethers } from 'ethers';

import QRCodeModal from './klip-qrcode-modal';
import { JSONRPCResponse, JSONRPCRequest, JSONRPCMethod } from './JSONRPC';
import { Web3Provider, RequestArguments } from './Web3Provider';
import { SubscriptionManager, SubscriptionNotification, SubscriptionResult } from './SubscriptionManager';

// TODO : dkeys WASM Go Initialize...
import './abc/sandbox/index';
import { controllers, accountRestApi, services, nonceTracker } from './abc/background/init';
import { DekeyData } from './abc/dekeyData';

const ErrorMsgProviderUndefined = 'RPC Url is not provided or chain id is different.';
const KlipUrl = 'https://klipwallet.com/?target=/a2a?request_key=';
export type Callback<T> = (err: Error | null, result: T | null) => void;

const { abcController, accountController, typedMessageController } = controllers;
const { abcService, gasService, mpcService, providerService, providerConnManager } = services;
import { abcAddUser, abcLogin, getSession, resetPassword, updateAbcAddress, userRegister } from './services/services';
import { AbcLoginResponse } from './abc/schema/account';
// import secureLocalStorage from 'react-secure-storage';
import { AbcLoginResult } from './abc/main/abc/interface';
import { addHexPrefix } from 'ethereumjs-util';
import GasUtil from './abc/utils/gas';
import { isKlaytn, isBinance } from './abc/utils/network';
import KlaytnUtil from './abc/utils/klaytn';
import TransactionUtil from './abc/utils/transaction';
import _ from 'lodash';
import { getGasPriceFromAPI } from './utils/getGasPrice';

export interface IAbcProviderOptions {
    bappName?: string;
    chainId?: string;
    rpcUrl?: string;
    email?: string;
    id_token?: string;
    serv?: string;
}

export interface IQRCodeModalOptions {
    registryUrl?: string;
    mobileLinks?: string[];
    desktopLinks?: string[];
}

interface ABCUnsignedTx {
    chainId: number;
    data: string;
    gasLimit: string;
    gasPrice: string;
    nonce: string;
    to: string;
    type?: number | undefined;
}

interface FeeData {
    gasPrice: BigNumber;
    lastBaseFeePerGas: BigNumber;
    maxFeePerGas: BigNumber;
    maxPriorityFeePerGas: BigNumber;
}

const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export class AbcWeb3Provider extends SafeEventEmitter implements Web3Provider {
    public qrcode = true;
    public chainId = '';
    public qrcodeModal = QRCodeModal;
    public qrcodeModalOptions: IQRCodeModalOptions | undefined = undefined;
    public bappName = '';
    public rpcUrl = '';
    public provider: any;
    public providerEnabled = false;
    // private readonly _subscriptionManager = new SubscriptionManager(this);
    private _addresses: string[] = [];
    public email = '';
    public id_token = '';
    public serv = '';
    public network = 0;

    constructor(opts: IAbcProviderOptions) {
        super({});
        this.bappName = opts.bappName ? opts.bappName : 'undefined';
        this.rpcUrl = opts.rpcUrl ? opts.rpcUrl : 'undefined';
        this.provider = this.rpcUrl != 'undefined' ? ethers.getDefaultProvider(this.rpcUrl) : undefined;
        this.chainId = opts.chainId;
        // this.chainId = this.getChainId();
        // this._subscriptionManager.events.on('notification', (notification: SubscriptionNotification) => {
        //     this.emit('message', {
        //         type: notification.method,
        //         data: notification.params,
        //     });
        // });
        switch (parseInt(this.chainId, 16)) {
            case 1:
                this.network = 0;
                break;
            case 11155111:
                this.network = 1;
                break;
            case 8217:
                this.network = 2;
                break;
            case 1001:
                this.network = 3;
                break;
            case 56:
                this.network = 4;
                break;
            case 97:
                this.network = 5;
                break;
            case 137:
                this.network = 6;
                break;
            case 80002:
                this.network = 7;
                break;
        }
        console.log('!! AbcWeb3Provider constructor : ', opts, this.network);
        this.email = opts.email ?? 'undefined';
        this.id_token = opts.id_token ?? 'undefined';
        this.serv = opts.serv ?? 'undefined';
    }

    private async _checkRpcUrl(): Promise<boolean> {
        const network = await this.provider.getNetwork();
        console.log('!! _checkRpcUrl : ', network);
        return network.chainId === parseInt(this.chainId, 16);
    }

    public getChainId(): string {
        return this.chainId;
    }

    public get connected(): boolean {
        return true;
    }

    public supportsSubscriptions(): boolean {
        return false;
    }

    public disconnect(): boolean {
        return true;
    }

    public send(request: JSONRPCRequest): JSONRPCResponse;
    public send(request: JSONRPCRequest[]): JSONRPCResponse[];
    public send(request: JSONRPCRequest, callback: Callback<JSONRPCResponse>): void;
    public send(request: JSONRPCRequest[], callback: Callback<JSONRPCResponse[]>): void;
    public send<T = any>(method: string, params?: any[] | any): Promise<T>;
    public send(
        requestOrMethod: JSONRPCRequest | JSONRPCRequest[] | string,
        callbackOrParams?: Callback<JSONRPCResponse> | Callback<JSONRPCResponse[]> | any[] | any,
    ): JSONRPCResponse | JSONRPCResponse[] | void | Promise<any> {
        // send<T>(method, params): Promise<T>
        if (typeof requestOrMethod === 'string') {
            const method = requestOrMethod;
            const params = Array.isArray(callbackOrParams)
                ? callbackOrParams
                : callbackOrParams !== undefined
                ? [callbackOrParams]
                : [];
            const request: JSONRPCRequest = {
                jsonrpc: '2.0',
                id: 0,
                method,
                params,
            };
            return this._sendRequestAsync(request).then((res) => res.result);
        }

        // send(JSONRPCRequest | JSONRPCRequest[], callback): void
        if (typeof callbackOrParams === 'function') {
            const request = requestOrMethod as any;
            const callback = callbackOrParams;
            return this._sendAsync(request, callback);
        }

        // send(JSONRPCRequest[]): JSONRPCResponse[]
        if (Array.isArray(requestOrMethod)) {
            const requests = requestOrMethod;
            return requests.map((r) => this._sendRequest(r));
        }

        // send(JSONRPCRequest): JSONRPCResponse
        const req: JSONRPCRequest = requestOrMethod;
        return this._sendRequest(req);
    }

    public sendAsync(request: JSONRPCRequest, callback: Callback<JSONRPCResponse>): void;
    public sendAsync(request: JSONRPCRequest[], callback: Callback<JSONRPCResponse[]>): void;

    public async sendAsync(
        request: JSONRPCRequest | JSONRPCRequest[],
        callback: Callback<JSONRPCResponse> | Callback<JSONRPCResponse[]>,
    ): Promise<void> {
        if (typeof callback !== 'function') {
            throw new Error('callback is required');
        }

        // send(JSONRPCRequest[], callback): void
        if (Array.isArray(request)) {
            const arrayCb = callback as Callback<JSONRPCResponse[]>;
            this._sendMultipleRequestsAsync(request)
                .then((responses) => arrayCb(null, responses))
                .catch((err) => arrayCb(err, null));
            return;
        }

        // send(JSONRPCRequest, callback): void
        const cb = callback as Callback<JSONRPCResponse>;
        return this._sendRequestAsync(request)
            .then((response) => cb(null, response))
            .catch((err) => cb(err, null));
    }

    public async request<T>(args: RequestArguments): Promise<T> {
        if (!args || typeof args !== 'object' || Array.isArray(args)) {
            throw ethErrors.rpc.invalidRequest({
                message: 'Expected a single, non-array, object argument.',
                data: args,
            });
        }

        const { method, params } = args;

        if (typeof method !== 'string' || method.length === 0) {
            throw ethErrors.rpc.invalidRequest({
                message: "'args.method' must be a non-empty string.",
                data: args,
            });
        }

        if (params !== undefined && !Array.isArray(params) && (typeof params !== 'object' || params === null)) {
            throw ethErrors.rpc.invalidRequest({
                message: "'args.params' must be an object or array if provided.",
                data: args,
            });
        }

        const newParams = params === undefined ? [] : params;

        const res = await this._sendRequestAsync({
            method,
            params: newParams,
            jsonrpc: '2.0',
            id: 0,
        });
        return res.result as T;
    }

    private _send = this.send.bind(this);
    private _sendAsync = this.sendAsync.bind(this);

    private _sendRequest(request: JSONRPCRequest): JSONRPCResponse {
        const response: JSONRPCResponse = {
            jsonrpc: '2.0',
            id: request.id,
        };
        const { method } = request;

        response.result = this._handleSynchronousMethods(request);

        if (response.result === undefined) {
            throw new Error(
                `Kaikas Wallet does not support calling ${method} synchronously without ` +
                    `a callback. Please provide a callback parameter to call ${method} ` +
                    `asynchronously.`,
            );
        }
        return response;
    }

    private _sendRequestAsync(request: JSONRPCRequest): Promise<JSONRPCResponse> {
        return new Promise<JSONRPCResponse>((resolve, reject) => {
            try {
                const syncResult = this._handleSynchronousMethods(request);
                if (syncResult !== undefined) {
                    return resolve({
                        jsonrpc: '2.0',
                        id: request.id,
                        result: syncResult,
                    });
                }

                const subscriptionPromise = this._handleSubscriptionMethods(request);
                if (subscriptionPromise !== undefined) {
                    subscriptionPromise
                        .then((res) =>
                            resolve({
                                jsonrpc: '2.0',
                                id: request.id,
                                result: res.result,
                            }),
                        )
                        .catch((err) => reject(err));
                    return;
                }
            } catch (err: any) {
                return reject(err);
            }

            this._handleAsynchronousMethods(request)
                .then((res) => res && resolve({ ...res, id: request.id }))
                .catch((err) => reject(err));
        });
    }

    private _handleSubscriptionMethods(request: JSONRPCRequest): Promise<SubscriptionResult> | undefined {
        // switch (request.method) {
        //     case JSONRPCMethod.eth_subscribe:
        //     case JSONRPCMethod.eth_unsubscribe:
        //         return this._subscriptionManager.handleRequest(request);
        // }

        return undefined;
    }
    private _sendMultipleRequestsAsync(requests: JSONRPCRequest[]): Promise<JSONRPCResponse[]> {
        return Promise.all(requests.map((r) => this._sendRequestAsync(r)));
    }

    private _handleSynchronousMethods(request: JSONRPCRequest) {
        const { method } = request;
        console.log('!! AbcWeb3Provider : sync method =====> ', method);

        switch (method) {
            case JSONRPCMethod.eth_accounts:
                return this._eth_accounts();

            case JSONRPCMethod.net_version:
                return this._net_version();

            case JSONRPCMethod.eth_chainId:
                return this._eth_chainId();

            default:
                return undefined;
        }
    }

    private async _handleAsynchronousMethods(request: JSONRPCRequest): Promise<JSONRPCResponse | void> {
        const { method } = request;
        const params = request.params || [];
        console.log('!! AbcWeb3Provider : async method =====> ', method);
        switch (method) {
            case JSONRPCMethod.eth_getBalance:
                return this._eth_getBalance(params);
            case JSONRPCMethod.personal_sign:
                return this._personal_sign(params);
            case JSONRPCMethod.eth_sendTransaction:
                return this._eth_sendTransaction(params);
            case JSONRPCMethod.personal_ecRecover:
                return this._personal_ecRecover(params);
            case JSONRPCMethod.eth_blockNumber:
                return this._eth_blockNumber();
            case JSONRPCMethod.eth_getBlockByNumber:
                return this._eth_getBlockByNumber(params);
            case JSONRPCMethod.eth_getGasPrice:
                return this._eth_getGasPrice();
            case JSONRPCMethod.eth_getTransactionByHash:
                return this._eth_getTransactionByHash(params);
            case JSONRPCMethod.eth_getTransactionReceipt:
                return this._eth_getTransactionReceipt(params);
            case JSONRPCMethod.eth_call:
                return this._eth_call(params);
            case JSONRPCMethod.eth_estimateGas:
                return this._eth_estimateGas(params);
            case JSONRPCMethod.eth_signTypedData_v4:
                return this._eth_signTypedData_v4(params);
        }
        throw new Error(`${method} is not supported in klip-web3-provider.`);
    }

    get isWalletConnect() {
        return true;
    }

    enable = async (): Promise<string[]> => {
        let abcAuth: AbcLoginResult = {
            accessToken: '',
            refreshToken: '',
            tokenType: '',
            expiresIn: 0,
        };

        console.log('----------------->', this.email, this.id_token);
        if (this.provider != undefined) {
            this.providerEnabled = await this._checkRpcUrl();
        }
        if (this._addresses.length > 0) {
            return this._addresses;
        }
        return new Promise(async (resolve, reject) => {
            //         const res = await prepare.auth({ bappName: this.bappName });
            //         if (res.err) {
            //             return reject(res.err);
            //         } else if (res.request_key) {
            //             const klipLink = KlipUrl + res.request_key;
            //             this.qrcodeModal.open(klipLink, () => {
            //                 this.emit('modal_closed');
            //             });
            //             const interval = setInterval(() => {
            //                 getResult(res.request_key).then((data: any) => {
            //                     if (data.status == 'completed') {
            //                         this.qrcodeModal.close();
            //                         clearInterval(interval);
            //                         this._addresses = [data.result.klaytn_address];
            //                         return resolve([data.result.klaytn_address]);
            //                     } else if (data.status == 'canceled' || data.status == 'error') {
            //                         this.qrcodeModal.close();
            //                         clearInterval(interval);
            //                         this._addresses = [];
            //                         return reject(new Error('Process is canceled or error occurs'));
            //                     }
            //                 });
            //             }, 1000);
            //             this.on('modal_closed', () => {
            //                 clearInterval(interval);
            //                 return reject(new Error('QRCode modal is closed!'));
            //             });
            //         }

            const isExist = await abcController.getUser({
                email: this.email,
                successIfUserExist: true,
            });
            console.log('!! AbcWeb3Provider : getUser =', isExist);

            if (isExist) {
                // ABC 로그인 후 지갑 복구 수행
                // let result;
                // try {
                //     result = await abcLogin({
                //         token: this.id_token,
                //         service: this.serv,
                //         audience: 'https://mw.myabcwallet.com',
                //     });
                //     console.log('!! AbcWeb3Provider : login result =', result.data);
                //
                //     if (result.data?.error) {
                //         this._addresses = [];
                //         return reject(new Error(result.data?.error_description));
                //     }
                // } catch (err: any) {
                //     this._addresses = [];
                //     alert('Login Session Time Out. Please Login again.');
                //     return reject(new Error(err.message));
                // }
                //
                // const resData = AbcLoginResponse.parse(result.data);
                // abcAuth = {
                //     accessToken: resData.access_token,
                //     refreshToken: resData.refresh_token,
                //     tokenType: resData.token_type,
                //     expiresIn: resData.expire_in,
                // };
                // secureLocalStorage.setItem('abcAuth', JSON.stringify(abcAuth));
                const abcAuth = JSON.parse(window.localStorage.getItem('abcAuth'));
                if (!abcAuth) return console.log('No abcAuth!!');
                const { user, wallets } = await accountRestApi.getWalletsAndUserByAbcUid(abcAuth);
                console.log('!! AbcWeb3Provider : getWalletsAndUserByAbcUid =', user, wallets);

                if (user) {
                    console.log('!! AbcWeb3Provider : user #1 =', user);
                    await accountController.recoverShare(
                        { password: '!owdin001', user, wallets, keepDB: false },
                        undefined,
                    );

                    this._addresses = [user.accounts[0].ethAddress];

                    // TODO : Initialize providerService - 다양한 체인을 지원 가능하게...
                    const networks = DekeyData.DEFAULT_NETWORKS;
                    // await providerService.connect(networks[this.chainId === '8217' ? 2 : 3], ''); // use Polygon Testnet
                    await providerService.connect(networks[this.network], '');

                    return resolve([user.accounts[0].ethAddress]);
                }
                this._addresses = [];
                return reject(new Error('Process is canceled or error occurs'));

                // TODO : 로그인 없이 Frontend 에서 저장해 둔 정보 사용 -> 추가 테스트 필요
                // const abcUser = JSON.parse(<string>await secureLocalStorage.getItem('abcUser'));
                // if (abcUser && abcUser?.accounts) {
                //     this._addresses = [abcUser.accounts[0].ethAddress];
                //
                //     // TODO : Initialize providerService - 다양한 체인을 지원 가능하게...
                //     const networks = DekeyData.DEFAULT_NETWORKS;
                //     await providerService.connect(networks[this.chainId === '137' ? 6 : 7], ''); // use Polygon Testnet
                //
                //     return resolve([abcUser.accounts[0].ethAddress]);
                // } else {
                //     this._addresses = [];
                //     return reject(new Error('Process is canceled or error occurs'));
                // }
            } else {
                this._addresses = [];
                return reject(new Error('Process is canceled or error occurs'));
            }
        });
    };

    private _eth_accounts(): string[] {
        return [...this._addresses];
    }

    private _net_version(): number {
        return 80002;
    }

    private _eth_chainId(): string {
        return this.getChainId();
    }

    private async _eth_estimateGas(params: unknown[]): Promise<JSONRPCResponse> {
        return new Promise<JSONRPCResponse>(async (resolve, reject) => {
            console.log('===== params =====> ', params);

            try {
                console.log('----- get nonce of the account : ', this._addresses[0]);
                try {
                    const { nextNonce } = await nonceTracker.getNetworkNonce(this._addresses[0]);
                    console.log('==== nextNonce ===>', nextNonce);
                } catch (err) {
                    console.log('---------->', err);
                }

                const latestBlock = await providerService.getLatestBlock();
                console.log('----- get last block : ', latestBlock);

                const { blockGasLimit, estimatedGasHex } = await gasService.analyzeGasUsage(
                    {
                        // @ts-ignore
                        data: params[0].data,
                        // @ts-ignore
                        from: params[0].from,
                        // @ts-ignore
                        to: params[0].to,
                        // @ts-ignore
                        value: params[0]?.value ? params[0]?.value : '0x0',
                    },
                    latestBlock,
                );

                const gasLimit = GasUtil.addGasBuffer(
                    addHexPrefix(estimatedGasHex),
                    blockGasLimit,
                    parseInt(this.chainId),
                );
                console.log('!! eth_estimateGas : ', gasLimit);

                return resolve({
                    jsonrpc: '2.0',
                    id: 0,
                    // TODO : 너무 작은 값이 나오는 것 아닌지 ?
                    result: gasLimit,
                    // result: '0x1312D00', // 20,000,000
                });
            } catch (err) {
                return reject(new Error('Process is canceled or error occurs'));
            }
        });
    }

    private async _personal_sign(params: unknown[]): Promise<JSONRPCResponse> {
        return new Promise<JSONRPCResponse>(async (resolve, reject) => {
            const bappName = this.bappName;
            const value = typeof params[0] === 'string' ? params[0] : 'undefined'; //message
            const from = params[1];
            //         const res = await prepare.signMessage({
            //             bappName,
            //             value: convertHexToUtf8(value),
            //             from,
            //         });
            //         if (res.err) {
            //             return reject(res.err);
            //         } else if (res.request_key) {
            //             const klipLink = KlipUrl + res.request_key;
            //             this.qrcodeModal.open(klipLink, () => {
            //                 this.emit('modal_closed');
            //             });
            //             const interval = setInterval(() => {
            //                 getResult(res.request_key).then((data: any) => {
            //                     if (data.status == 'completed') {
            //                         this.qrcodeModal.close();
            //                         clearInterval(interval);
            //                         return resolve({
            //                             jsonrpc: '2.0',
            //                             id: 0,
            //                             result: data.result.signature,
            //                         });
            //                     } else if (data.status == 'canceled' || data.status == 'error') {
            //                         this.qrcodeModal.close();
            //                         clearInterval(interval);
            //                         return reject(new Error('Process is canceled or error occurs'));
            //                     }
            //                 });
            //             }, 1000);
            //             this.on('modal_closed', () => {
            //                 clearInterval(interval);
            //                 return reject(new Error('QRCode modal is closed!'));
            //             });
            //         }
        });
    }

    private async _eth_signTypedData_v4(params: any[]): Promise<JSONRPCResponse> {
        // send token transaction & send klay transaction
        return new Promise<JSONRPCResponse>(async (resolve, reject) => {
            console.log('!! _eth_signTypedData_v4 params : ', params);
            const from = params[0];
            const data = typeof params[1] === 'string' ? params[1] : 'undefined'; //Typed Data

            // const abcUser = JSON.parse(<string>secureLocalStorage.getItem('abcUser'));
            const abcUser = JSON.parse(window.localStorage.getItem('abcUser'));
            const target = {
                id: '999',
                msgParams: {
                    from,
                    data,
                    version: 'V4',
                },
            };
            console.log('!! _eth_signTypedData_v4 signing : ', data, abcUser.accounts[0]);
            // const signature = await typedMessageController.signTypedMessage(target, abcUser.accounts[0]);
            const signature = await typedMessageController.signTypedMessageV4(data, abcUser.accounts[0]);
            console.log('!! _eth_signTypedData_v4 signature : ', signature);

            return resolve({
                jsonrpc: '2.0',
                id: 0,
                result: signature,
            });
        });
    }

    private async _eth_sendTransaction(params: any[]): Promise<JSONRPCResponse> {
        // send token transaction & send klay transaction
        return new Promise<JSONRPCResponse>(async (resolve, reject) => {
            console.log('!! _eth_sendTransaction : ', params);
            // if (params[0].hasOwnProperty('data') && params[0]['data'] != '') {
            //     return reject(new Error('This provider cannot be used to execute smart contract functions.'));
            // }

            // TODO : 멀티체인 지원하게 수정 필요함.
            // 1. 블록체인 네트워크 연결
            const networks = DekeyData.DEFAULT_NETWORKS;
            // console.log('!! providerService connect : ', networks[parseInt(this.chainId, 16) === 8217 ? 2 : 3]);
            // await providerService.connect(networks[parseInt(this.chainId, 16) === 8217 ? 2 : 3], ''); // use Klaytn Testnet
            // // console.log('!! providerService connect : ', networks[parseInt(this.chainId, 16) === 137 ? 6 : 7]);
            // // await providerService.connect(networks[parseInt(this.chainId, 16) === 137 ? 6 : 7], ''); // use Mumbai Testnet
            console.log('!! providerService connect : ', networks[this.network]);
            await providerService.connect(networks[this.network], '');

            // const bappName = this.bappName;
            // const to = params[0]['to'];
            // const amount = (Number(params[0]['value']) * Number(10 ** -18)).toFixed(6).toString();

            console.log('----- get nonce of the account : ', this._addresses[0]);
            try {
                const { nextNonce } = await nonceTracker.getNetworkNonce(this._addresses[0]);
                console.log('==== nextNonce ===>', nextNonce);
                params[0].nonce = nextNonce;
            } catch (err) {
                console.log('---------->', err);
            }
            params[0].chainId = parseInt(this.chainId, 16);
            let txParams = params[0];
            console.log('=== txParams ===>', txParams);

            // const res = await prepare.sendKLAY({
            //     bappName,
            //     to,
            //     amount,
            // });
            //
            // if (res.err) {
            //     return reject(res.err);
            // } else if (res.request_key) {
            //     const klipLink = KlipUrl + res.request_key;
            //     this.qrcodeModal.open(klipLink, () => {
            //         this.emit('modal_closed');
            //     });
            //     const interval = setInterval(() => {
            //         getResult(res.request_key).then((data: any) => {
            //             if (data.status == 'completed') {
            //                 this.qrcodeModal.close();
            //                 clearInterval(interval);
            //                 return resolve({
            //                     jsonrpc: '2.0',
            //                     id: 0,
            //                     result: data.result.tx_hash,
            //                 });
            //             } else if (data.status == 'canceled' || data.status == 'error') {
            //                 this.qrcodeModal.close();
            //                 clearInterval(interval);
            //                 return reject(new Error('Process is canceled or error occurs'));
            //             }
            //         });
            //     }, 1000);
            //     this.on('modal_closed', () => {
            //         clearInterval(interval);
            //         return reject(new Error('QRCode modal is closed!'));
            //     });
            // }

            this.qrcodeModal.open('DEFAULT', async (abcToken: string) => {
                // this.emit('modal_closed');
                console.log('!! twoFaToken : ', abcToken);
                if (abcToken === null || abcToken === undefined || abcToken === '') {
                    return reject('User canceled transaction');
                }

                let feeData: FeeData = await this.provider.getFeeData();
                console.log('!! EIP-1559 Fee Data : ', feeData);
                let maxFeePerGas;
                let maxPriorityFeePerGas;
                if (this.network === 6) {
                    maxFeePerGas = ethers.utils.formatUnits(feeData['maxFeePerGas'].mul(BigNumber.from(20)), 'gwei');
                    maxPriorityFeePerGas = ethers.utils.formatUnits(
                        feeData['maxPriorityFeePerGas'].mul(BigNumber.from(20)),
                        'gwei',
                    );
                } else {
                    maxFeePerGas = ethers.utils.formatUnits(feeData['maxFeePerGas'], 'gwei');
                    maxPriorityFeePerGas = ethers.utils.formatUnits(feeData['maxPriorityFeePerGas'], 'gwei');
                }
                const gasPrice = await getGasPriceFromAPI(this.rpcUrl, parseInt(this.chainId));

                try {
                    // 7. 구글 OTP -> mpcToken 획득
                    // const txParamsTest = {
                    //     chainId: 1001,
                    //     data: '0x095ea7b30000000000000000000000001716c4d49e9d81c17608cd9a45b1023ac9df6c73000000000000000000000000000000000000000000000000016345785d8a0000',
                    //     // from: '0x574caab053de2e7accfb088fb6c2bca3e335c4a0',
                    //     gasLimit: '0x1395b',
                    //     gasPrice: '0xba43b7400',
                    //     nonce: '0x01',
                    //     to: '0xae16dd27539a255a43596481d0f0824ced8170e1',
                    // };

                    console.log(
                        '!! EIP-1559 maxFeePerGas, maxPriorityFeePerGas, gasPrice : ',
                        maxFeePerGas,
                        maxPriorityFeePerGas,
                        gasPrice,
                    );
                    const gasData = GasUtil.makeGasData(maxFeePerGas, maxPriorityFeePerGas, gasPrice);
                    console.log('!! EIP-1559 Calculated Gas Data : ', gasData);

                    // txParams.maxPriorityFeePerGas = feeData['maxPriorityFeePerGas'];
                    // txParams.maxFeePerGas = feeData['maxFeePerGas'];
                    // txParams = { ...txParams, ...gasData, type: 2 };

                    const { chainId, nonce, to, value, type, data, from, gasLimit, gas } = txParams;
                    console.log('txParams:::', txParams);
                    // TODO : Klaytn, Binance 는 Legacy 만 지원함.
                    const abcTxParams = {
                        chainId: chainId,
                        gasLimit: BigNumber.from(gasLimit ?? gas).toHexString(), // in case of Klaytn not gasLimit but gas ?!
                        nonce: nonce,
                        ...(!isKlaytn(chainId) &&
                            !isBinance(chainId) && {
                                maxFeePerGas: gasData.maxFeePerGas,
                                maxPriorityFeePerGas: gasData.maxPriorityFeePerGas,
                            }),
                        ...((isKlaytn(chainId) || isBinance(chainId)) && { gasPrice: gasPrice }),
                        ...(to && { to: to }),
                        ...(value && { value: value }),
                        ...(!isKlaytn(chainId) && !isBinance(chainId) && Boolean(gasData.maxFeePerGas) && { type: 2 }),
                        ...((isKlaytn(chainId) || isBinance(chainId)) && type && { type: type }),
                        ...(data && { data: data }),
                        ...(isKlaytn(chainId) && type && { from: from }), // from : only klaytn
                    };

                    // const tmpTxParams = _.omit(txParams, ['from']);
                    // // @ts-ignore
                    // const abcTxParams: ABCUnsignedTx = {};
                    // delete Object.assign(abcTxParams, tmpTxParams, { ['gasLimit']: tmpTxParams['gas'] })['gas'];
                    // // const abcTxParams = _.omit(txParams, ['from', 'gas']);

                    // const abcTxParams = _.mapValues(tmpTxParams2, (value: string | number | BigNumber, key) => {
                    //     if (key === 'gasLimit') {
                    //         value = ethers.BigNumber.from(value);
                    //     }
                    //     return value;
                    // });
                    // console.log('===== tmpTxParams =====', tmpTxParams);
                    console.log('===== abcTxParams =====', abcTxParams);

                    // const altObj = Object.fromEntries(
                    //     Object.entries(txParamsTest).map(([key, value]) =>
                    //         // Modify key here
                    //         [`x-${key}`, value],
                    //     ),
                    // );

                    const mpcToken = await accountController.verifyTwofactorForMpcSign({
                        // @ts-ignore
                        twofaToken: abcToken,
                        jsonUnsignedTx: JSON.stringify(abcTxParams),
                    });
                    console.log('===== mpcToken ===>', mpcToken);

                    // 8. Target Sign Message
                    const messageHash =
                        isKlaytn(txParams.chainId) && txParams?.type
                            ? KlaytnUtil.createTxHash(txParams)
                            : TransactionUtil.createTxHash(abcTxParams);
                    console.log('=== messageHash ===>', messageHash);

                    const abcUser = JSON.parse(window.localStorage.getItem('abcUser'));
                    // const abcUser = secureLocalStorage.getItem('abcUser');
                    await accountController.unlock({ password: '!owdin001' }, abcUser);

                    // 9. TX Signing
                    const account = abcUser.accounts[0];
                    const sResult = await mpcService.sign({
                        txHash: messageHash.slice(2),
                        mpcToken,
                        accountId: account.id,
                    });
                    console.log('=== sResult ===>', sResult);

                    const { r, s, vsource } = sResult;
                    const v = TransactionUtil.calculateV({
                        r,
                        s,
                        vsource,
                        hash: messageHash,
                        address: account.ethAddress,
                        chainId: parseInt(abcTxParams.chainId.toString()),
                    });

                    // 10. signed Raw Tx
                    // @ts-ignore
                    console.log('!!!!!!!!!!!!!!!!!!!!!!!!!!', abcTxParams);
                    const rawTx =
                        isKlaytn(<number>abcTxParams.chainId) && abcTxParams?.type
                            ? await KlaytnUtil.createRawTx({ txParams: abcTxParams, v, r, s })
                            : TransactionUtil.createRawTx({ txParams: abcTxParams, v, r, s });
                    console.log('==== rawTx ===>', rawTx);

                    // 11. Broadcast signed raw Tx to the chain
                    const txHash = await providerConnManager.broadcastTx(rawTx, undefined, undefined);
                    console.log('=====> result: txHash ===>', txHash);

                    return resolve({
                        jsonrpc: '2.0',
                        id: 0,
                        result: txHash,
                    });
                } catch (e: any) {
                    return reject(new Error(e.message));
                }
            });
        });
    }

    private async _eth_call(params: unknown[]): Promise<JSONRPCResponse> {
        if (this.provider == undefined || !this.providerEnabled) {
            throw new Error(ErrorMsgProviderUndefined);
        }
        const result = await this.provider.call(params[0], params[1]);
        console.log('!! _eth_call : ', result);
        return { jsonrpc: '2.0', id: 0, result };
    }

    private async _eth_getBalance(params: unknown[]): Promise<JSONRPCResponse> {
        if (this.provider == undefined || !this.providerEnabled) {
            throw new Error(ErrorMsgProviderUndefined);
        }
        console.log('!! _eth_getBalance : ', params[0]);
        const result = await this.provider.getBalance(params[0]);
        console.log('!! _eth_getBalance : ', result);
        return { jsonrpc: '2.0', id: 0, result };
    }

    private async _personal_ecRecover(params: unknown[]): Promise<JSONRPCResponse> {
        if (this.provider == undefined || !this.providerEnabled) {
            throw new Error(ErrorMsgProviderUndefined);
        }
        const address = await this.provider.utils.recover(params[0], params[1]);
        console.log('!! _personal_ecRecover : ', address);
        return { jsonrpc: '2.0', id: 0, result: address };
    }

    private async _eth_getTransactionReceipt(params: unknown[]): Promise<JSONRPCResponse> {
        if (this.provider == undefined || !this.providerEnabled) {
            throw new Error(ErrorMsgProviderUndefined);
        }
        const receipt = await this.provider.getTransactionReceipt(params[0]);
        console.log('!! _eth_getTransactionReceipt : ', receipt);
        return { jsonrpc: '2.0', id: 0, result: receipt };
    }

    private async _eth_getTransactionByHash(params: unknown[]): Promise<JSONRPCResponse> {
        if (this.provider == undefined || !this.providerEnabled) {
            throw new Error(ErrorMsgProviderUndefined);
        }
        const tx = await this.provider.getTransaction(params[0]);
        console.log('!! _eth_getTransactionByHash : ', tx);
        return { jsonrpc: '2.0', id: 0, result: tx };
    }

    private async _eth_blockNumber(): Promise<JSONRPCResponse> {
        if (this.provider == undefined || !this.providerEnabled) {
            throw new Error(ErrorMsgProviderUndefined);
        }
        const blockNumber = await this.provider.getBlockNumber();
        console.log('!! _eth_blockNumber : ', blockNumber);
        return { jsonrpc: '2.0', id: 0, result: blockNumber };
    }

    private async _eth_getBlockByNumber(params: unknown[]): Promise<JSONRPCResponse> {
        if (this.provider == undefined || !this.providerEnabled) {
            throw new Error(ErrorMsgProviderUndefined);
        }

        // const block = await this.provider.rpc.klay.getBlockByNumber(params[0], params[1]);

        let number;
        if (params[0] === 'latest') number = await this.provider.getBlockNumber();
        else number = params[0];

        let block;
        if (params[1]) block = await this.provider.getBlockWithTransactions(number);
        else block = await this.provider.getBlock(number);

        console.log('!! _eth_getBlockByNumber : ', block);
        return { jsonrpc: '2.0', id: 0, result: block };
    }

    private async _eth_getGasPrice(): Promise<JSONRPCResponse> {
        if (this.provider == undefined) {
            throw new Error(ErrorMsgProviderUndefined);
        }
        const result = await this.provider.getGasPrice();
        console.log('!! _eth_getGasPrice : ', result);
        return { jsonrpc: '2.0', id: 0, result: result };
    }
}
